var map = {
	"./airtable.svg": 484,
	"./audio.svg": 485,
	"./confluence.svg": 486,
	"./database.svg": 487,
	"./disc.svg": 488,
	"./ebook.svg": 489,
	"./evernote.svg": 490,
	"./exe.svg": 491,
	"./file.svg": 492,
	"./folder.svg": 282,
	"./font.svg": 493,
	"./google_excel.svg": 494,
	"./google_form.svg": 495,
	"./google_powerpoint.svg": 496,
	"./google_word.svg": 497,
	"./illustrator.svg": 498,
	"./image.svg": 499,
	"./indesign.svg": 500,
	"./keynote.svg": 501,
	"./miro.svg": 502,
	"./office_excel.svg": 503,
	"./office_powerpoint.svg": 504,
	"./office_word.svg": 505,
	"./onenote.svg": 506,
	"./paper.svg": 507,
	"./pdf.svg": 508,
	"./photoshop.svg": 509,
	"./presentation.svg": 510,
	"./quip.svg": 511,
	"./script.svg": 512,
	"./sketch.svg": 513,
	"./system.svg": 514,
	"./text.svg": 515,
	"./url.svg": 516,
	"./video.svg": 517,
	"./word.svg": 518,
	"./zip.svg": 519
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 483;